/** Display tiers follow catalog group_id; product_id remains an opaque checkout key. */
export function planTier(plan) {
  if (['basic', 'lite', 'starter'].includes(plan?.group_id)) return 'starter';
  return ['free', 'pro'].includes(plan?.group_id) ? plan.group_id : '';
}

export function planDisplayName(plan, t) {
  const tier = planTier(plan);
  if (tier === 'free') return t('billing.freePlanShort');
  if (tier) return t('t36Paywall.' + tier + 'Plan');
  return plan?.name?.trim() || t('billing.subscriptionOnFile');
}
